import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Services from './components/Services';
import Tools from './components/Tools';
import Process from './components/Process';
import Blog from './components/Blog';
import About from './components/About';
import Contact from './components/Contact';
import Footer from './components/Footer';

function WhatsAppButton() {
  return (
    <a
      href="https://wa.me/905300953230"
      target="_blank"
      rel="nofollow noreferrer"
      className="fixed bottom-6 right-6 z-50 w-13 h-13 flex items-center justify-center bg-[#25D366] text-white rounded-full hover:scale-110 transition-transform cursor-pointer"
      style={{ width: 52, height: 52 }}
      aria-label="WhatsApp ile iletişime geç"
    >
      <i className="ri-whatsapp-line text-2xl"></i>
    </a>
  );
}

function ScrollTopButton() {
  const handleClick = () => window.scrollTo({ top: 0, behavior: 'smooth' });
  return (
    <button
      onClick={handleClick}
      className="fixed bottom-24 right-6 z-50 w-10 h-10 flex items-center justify-center bg-[#0A2540] text-white rounded-full hover:scale-110 transition-transform cursor-pointer"
      aria-label="Yukarı çık"
    >
      <i className="ri-arrow-up-line text-base"></i>
    </button>
  );
}

export default function HomePage() {
  return (
    <main className="min-h-screen">
      <Navbar />
      <Hero />
      <Services />
      <Tools />
      <Process />
      <Blog />
      <About />
      <Contact />
      <Footer />
      <WhatsAppButton />
      <ScrollTopButton />
    </main>
  );
}
